import "./managedFunds.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import mfBanner from "../images/mf-banner.jpg";
import mpFeatures from "../images/mp-features.jpg";
import handshake from "../images/Handshake.png";
import bank from "../images/Bank.png";
import mfStart from "../images/mf-start.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Mf = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");


  
                        useEffect( () => {
                                   AOS.init({
                                      offset: 0,
                                      duration: 1000,
                                      once: true
                               });
                                                
                                                    
                               }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              nodes {
                managedFund {
                  hero {
                    buttonLink
                    buttonName
                    heading
                    caption
                    image {
                      mediaItemUrl
                    }
                  }
                  productText
                  heromobile {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                  productInfo {
                    explanation
                    heading
                    icon {
                      mediaItemUrl
                    }
                  }
                  section {
                    buttonLink
                    buttonName
                    explanation
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.nodes[22].managedFund.hero);
        setHeroMobile(result.data.pages.nodes[22].managedFund.heromobile);
        setProductInfo(result.data.pages.nodes[22].managedFund.productInfo);
        setBusinessSections(result.data.pages.nodes[22].managedFund.section);
        setProductText(result.data.pages.nodes[22].managedFund.productText);
        setProductTextContd(
          result.data.pages.nodes[22].managedFund.productTextContd,
        );
      });
  }, []);

  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let businessSectionsDisplay;
  let productInfoDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mf-txt">
            <h1 className="mf-h1 "  data-aos="zoom-in" data-aos-delay="200">{banner.heading} </h1>
            <p className="grey-p-mf"  data-aos="fade-up" data-aos-delay="200">{banner.caption} </p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mf-txt">
            <h1 className="mf-h1" data-aos="zoom-in" data-aos-delay="200">{banner.heading} </h1>
            <p className="grey-p-mf" data-aos="fade-up" data-aos-delay="200">{banner.caption} </p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >


          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
          
          <div className="values-mfs compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.explanation}
            </p>

            <Link
              class="open-acc-btn grey-p mt-3"
              to={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
             
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>

        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-mfs compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.explanation}
            </p>

            <Link
              class="open-acc-btn grey-p mt-3"
              to={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) => (
      <div className="card mf-crd">
        <div className="text-start">
          <img className="pb-5" src={info.icon.mediaItemUrl} data-aos="fade-up" data-aos-delay="200" />
          <h4 className="card-subtitle mb-1 statement-hdr" data-aos="fade-up" data-aos-delay="200"> {info.heading} </h4>
          <p className="card-text pt-3 grey-p-mf" style={{ fontSize: "16px" }} data-aos="fade-up" data-aos-delay="200">
            {info.explanation}
          </p>
        </div>
      </div>
    ));
  }

  return (
    <>
      <div className="mp-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="mp-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty">
            <h2 className="mf-h2 pb-4">What is Managed Funds? </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p-mf grey-color">{productText} </p>

            <p className="grey-p-mf mt-3 grey-color">{productTextContd} </p>
          </div>
        </div>
      </div>

      <div className="plain-cont">
        <div
          id="mobile-view"
          className="containeer row d-flex justify-content-between text-center "
        >
          <div className="text-center pb-5">
            <p className="orange-p-mf pb-2">WHAT WE MANAGE</p>
            <h2 className="mf-h2 dark-text">Specialized Fund Solutions</h2>
            <p className="grey-p-mf dark-text-2">
              We help organizations manage Gratuity and Legacy Funds with clear
              structure and expert oversight.
            </p>
          </div>
          <div id="mobile-view" className="d-flex justify-content-between">
            {productInfoDisplay}
          </div>
        </div>
      </div>

      <div className="containeer">{businessSectionsDisplay}</div>

          
      <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Mf;
